module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Gd-Hc-Ia.1ad04c42.png";